import { terUtilsUnitsMilimetriToMetri, terUtilsUnitsMilimetriKvadratniToMetriKvadratni } from './ter-utils';
import { ROUNDDOWN, XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { DOT, SLASH, SPACE } from '../utils/frfr-string-consts';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';


/*
export const derivatPoluproizvod_spoljnafiksnazaluzina_dopuni = (p) => {
  // SPECIJALNI KORAK
  // _____ dodajemo neke podatke koji su mu potrebni!

};
*/


export const derivatAutoCreateVirtel_spoljnafiksnazaluzina_priprema_ulaza = (p) => {

  const kolicina = p.kolicina;
  const unutrasnjasirina = p.unutrasnjasirina;
  const unutrasnjavisina = p.unutrasnjavisina;

  const pods_input = {
    kolicina,
    unutrasnjasirina,
    unutrasnjavisina
  };

  return pods_input;
};


// Novi derivat po uzoru na Excel iz Kladova
export const derivatAutoCreateVirtel_spoljnafiksnazaluzina = (pods_input) => {
  console.log('derivatAutoCreateVirtel_spoljnafiksnazaluzina(pods_input) ');
  console.log(pods_input);
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela
  const I3 = pods_input.unutrasnjasirina;
  const I4 = pods_input.unutrasnjavisina;
  const I5 = pods_input.kolicina;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // derivat 1 
  // derivat local 1
  _derivat_key = "derivat1";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$derivat1',
    virtelclass: "terkk$spoljnafiksnazaluzina$profil",
    kolicina: 2,
    // _oznaka: "P121",
    // calculated_ident: 'PP121AA000006000',
    calculated_ident: 'PP121AA00000',
    naziv: 'PROFIL ALUMINIJUM SPOLJNA FIKSNA P 121 6000mm',
  };
  x.duzina = I3 - 80;
  x.tip = x.calculated_ident;
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$spoljnafiksnazaluzina$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 1.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_spoljnafiksnazaluzina_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 2
  // derivat local 2
  _derivat_key = "derivat2";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$derivat1',
    virtelclass: "terkk$spoljnafiksnazaluzina$profil",
    kolicina: 2,
    // _oznaka: "P121",
    // calculated_ident: 'PP121AA000006000',
    calculated_ident: 'PP121AA00000',
    naziv: 'PROFIL ALUMINIJUM SPOLJNA FIKSNA P 121 6000mm',
  };
  x.duzina = I4 - 80;
  x.tip = x.calculated_ident;
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$spoljnafiksnazaluzina$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 2.1
  _derivat_key = "derivat2" + '_m';
  _mat = _derivat_spoljnafiksnazaluzina_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 3
  // derivat local 3
  _derivat_key = "derivat3";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$derivat1',
    virtelclass: "terkk$spoljnafiksnazaluzina$profil",
    // _oznaka: "P121",
    // calculated_ident: 'PP101AA000006000',
    calculated_ident: 'PP101AA00000',
    naziv: 'PROFIL ALUMINIJUM SPOLJNA FIKSNA P 101 6000mm',
  };
  x.kolicina = ROUNDDOWN((I4 - 63) / 83.2, 0) + 1;
  const K11 = x.kolicina;
  x.duzina = I3 - 58;
  const M11 = x.duzina;
  x.tip = x.calculated_ident;
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$spoljnafiksnazaluzina$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 3.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_spoljnafiksnazaluzina_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // ZATIM SLEDI JOS 3 MATERIJALA ZA SPOLJNUFIKSNUZALUZINA


  // derivat 4
  // derivat local 4 MATERIJAL
  _derivat_key = 'SPF_ROGALJ';
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_KOM,
    kolicina: 4,
    calculated_ident: 'B100010000000001',
    naziv: 'OSTALO SPOLJNA FIKSNA A 121 ROGALJ',
    tip: ''
  };
  x.duzina = XIF(I3 > 1250, ((I3 - 35) / 2) - 3, I3 - 3);
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 5
  // derivat local 5 MATERIJAL
  _derivat_key = 'SPF_DISTANCER';
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_KOM,
    calculated_ident: 'B100010000000007',
    naziv: 'OSTALO SPOLJNA FIKSNA DISTANCER N 827',
    tip: ''
  };
  // x.kolicina = (K11 + 1) * 2;
  x.kolicina = ROUNDDOWN((I4 - 63) / 83.2, 0) + 1;
  // x.duzina = XIF(I3 > 1250, M11, 0);
  x.duzina = I3 - 58;
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 6
  // derivat local 6 MATERIJAL
  _derivat_key = 'SPF_METAL';
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$spoljnafiksnazaluzina$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_M2,
    calculated_ident: 'A070000000000010',
    naziv: 'METAL ISTEGNUTI ALUMINIJUM LD 25',
    tip: ''
  };
  // x.kolicina = ROUNDUP((I3-5)*(I4-5)/1000000,2);
  x.duzina = I3 - 5;
  x.sirina = I4 - 5;
  x.kolicina = terUtilsUnitsMilimetriKvadratniToMetriKvadratni(x.duzina * x.sirina, 2);
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  console.log(z);

  
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


const _derivat_spoljnafiksnazaluzina_materijal1_by_pp = (p) => {
  // TODO: proveriti da li i p prima prirubnicu kao input ili daje kao rezultat...

  const _materijal_priprema_ulaza = (p) => {
    const _materijal_naziv = p._materijal_naziv;
    const tip = p.tip;
    const duzina = p.duzina;
    const pods_input = {
      tip,
      duzina,
      _materijal_naziv
    };
    return pods_input;
  };

  const _materijal_make = (pods_input) => {
    // dodajem mu materijal!
    // let z;
    let x = {
      naziv: pods_input._materijal_naziv
    };
    x.calculated_ident = pods_input.tip;
    x.terkategorija = 'M';
    let _kolicina = pods_input.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3); // KONVERTUJEMO U METRE
    x.jm = tclocal.JM_M;
    // z["derivat2"] = x;
    // posto materijal nece na backendu da se cuva odmah ovde delimicno kompletiramo virtel plitki
    const virtel_plitki_materijal = {
      // ...pods_input,
      ...x
    };
    return virtel_plitki_materijal;

    // TODO: ovde imamo dva puta polje kolicina
  };

  const pods_input = _materijal_priprema_ulaza(p);
  const materijal = _materijal_make(pods_input);
  return materijal;
};

